module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-01.9c92b12d.jpg";